<div class="sb-step">
  <div class="sb-step__main">
    <segment-review-card />

    @if (errorMsg) {
      <p class="sb-error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ errorMsg }}
      </p>
    }

    <div class="sb-bar">
      <div class="sb-bar__group">
        <button type="button" class="bk-btn bk-btn--ghost" [disabled]="saving" (click)="cancel()">Cancel</button>
        <button type="button" class="bk-btn bk-btn--ghost" [disabled]="saving" (click)="goToPrevious()">
          <span class="bk-sym" aria-hidden="true">arrow_back</span>
          Previous
        </button>
      </div>
      <div class="sb-bar__group">
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="saving"
          [attr.aria-busy]="saving || null"
          (click)="createSegment()"
        >
          {{ saving ? (isEditView ? 'Saving…' : 'Creating…') : actionButtontext }}
        </button>
      </div>
    </div>
  </div>

  <div class="sb-step__aside sb-step__aside--preview">
    <segment-preview [rules]="rules" />
  </div>
</div>
